import { TurnoverByBrokersReportData } from "../../../../data/reports/exchbusiness/tradeByBrokers/types";
import React from "react";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { Column } from "material-table";

export const useTradeByBrokersColumns = () => {
  const { getString, getFormatedNumberString } = React.useContext(
    LocalizationContext
  );

  return React.useMemo(
    () => [
      {
        title: getString("exchDate"),
        field: "date",
        sorting: false,
      },
      {
        title: getString("exchProduct"),
        field: "product",
        sorting: false,
      },
      {
        title: getString("exchSellerBroker"),
        field: "brokerSeller",
        sorting: false,
      },
      {
        title: getString("exchSeller"),
        field: "seller",
        sorting: false,
      },
      {
        title: getString("exchBuyerBroker"),
        field: "brokerBuyer",
        sorting: false,
      },
      {
        title: getString("exchBuyer"),
        field: "buyer",
        sorting: false,
      },
      {
        title: getString("exchQuantity"),
        render: (row) => `${getFormatedNumberString(row.quantity)}`,
        sorting: false,
        cellStyle: {
          whiteSpace: "nowrap",
          textAlign: "end",
        },
        headerStyle: {
          textAlign: "end",
        },
      },
      {
        title: getString("exchPrice"),
        render: (row) => `${getFormatedNumberString(row.price, true)}`,
        sorting: false,
        cellStyle: {
          whiteSpace: "nowrap",
          textAlign: "end",
        },
        headerStyle: {
          textAlign: "end",
        },
      },
      {
        title: getString("exchAmount"),
        render: (row) => `${getFormatedNumberString(row.amount, true)}`,
        sorting: false,
        cellStyle: {
          whiteSpace: "nowrap",
          textAlign: "end",
        },
        headerStyle: {
          textAlign: "end",
        },
      },
    ],
    [getString, getFormatedNumberString]
  ) as Column<TurnoverByBrokersReportData>[];
};
